module.exports = __webpack_public_path__ + "img/saleban.png";